/**
 * Sync product-gallery main image when product-info fires pi:variant-change.
 *
 * Rather than reconstructing an image URL from the variant's raw JSON data,
 * this finds the gallery thumbnail that already represents the variant's
 * media (every product image is already rendered as a thumbnail) and
 * triggers a real click on it — reusing the exact same swap logic/quality
 * as a manual thumbnail click, instead of a separate, easier-to-break path.
 */
(function () {
  function resolveVariantMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media?.id) return String(variant.featured_media.id);
    if (variant.featured_image?.id) return String(variant.featured_image.id);
    return null;
  }

  function updateGallery(gallery, variant) {
    const mediaId = resolveVariantMediaId(variant);
    if (!mediaId) return;

    const match = gallery.querySelector(`[data-media-id="${mediaId}"]`);
    if (!match) return;

    if (!match.classList.contains('is-active')) {
      match.click();
    }
  }

  document.addEventListener('pi:variant-change', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    document.querySelectorAll('[data-pi-product-gallery]').forEach((gallery) => {
      updateGallery(gallery, variant);
    });
  });

  /**
   * Pre-warm the full-size gallery images into the browser cache once the page
   * is idle. Thumbnails only render at 240px, so without this the first switch
   * to a given variant image blocks on a fresh CDN download (~0.5-1s). Warming
   * them makes the swap paint instantly. Purely additive: no markup, event, or
   * swap-logic changes, and it reuses the exact src/srcset/sizes the swap uses.
   */
  function warmGalleryImages() {
    const conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;

    const seen = new Set();
    document
      .querySelectorAll('[data-pi-product-gallery] [data-pi-gallery-thumb]')
      .forEach((thumb) => {
        const src = thumb.getAttribute('data-full-src');
        if (!src || seen.has(src)) return;
        seen.add(src);

        const img = new Image();
        const srcset = thumb.getAttribute('data-full-srcset');
        if (srcset) {
          img.srcset = srcset;
          img.sizes = '(min-width: 1200px) 720px, (min-width: 990px) 60vw, 100vw';
        }
        img.decoding = 'async';
        img.src = src;
      });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(warmGalleryImages, { timeout: 2500 });
  } else {
    window.addEventListener('load', () => setTimeout(warmGalleryImages, 500));
  }
})();
